// extracted by mini-css-extract-plugin
export default {"item":"SelectedState_item__8eAEy","name":"SelectedState_name__y8p5T","close":"SelectedState_close__UXDim","closeIcon":"SelectedState_closeIcon__ov4YN"};